import React, { PureComponent } from "react";

import { Modal, ModalHeader, ModalBody } from "reactstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { router } from "util/routing/Routing";

import { translate, Label } from "clavis-nxt-components-custdevtm";

import "./LogOutModal.scss";

/**
 * LogOut modal
 * @author kiv
 */

class LogOutModalComponent extends PureComponent {
  static displayName = "LogOutModal";

  constructor(props) {
    super(props);

    this.state = {
      counter: this.props.counter
    };
  }

  componentDidMount() {
    let counter = this.props.counter - 1000;
    this.setCounter(counter);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen) {
      const counter = this.state.counter;
      if (counter < this.props.counter && counter >= 0) {
        if (counter <= 0) {
          this.props.handleOnIdle();
        }
        setTimeout(() => this.setCounter(counter - 1000), 1000);
      }
    }
  }

  componentWillUnmount() {
    this.setCounter(this.props.counter);
  }

  setCounter = counter => {
    this.setState({ counter });
  };

  render() {
    const { t } = this.props;
    let sec = this.state.counter / 1000;
    return (
      <Modal
        wrapClassName="custdevtm-logout"
        className="log-out-modal"
        size={"lg"}
        isOpen={this.props.isOpen}
      >
        <ModalHeader>
          <div className="upper-row">
            <i
              className={
                "big-font-medium active-color icon-cp-excalamation-mark icon-normal"
              }
            />
            <span className={"big-font-medium header-color"}>
              {t("cdt.exitWarning.title")}
            </span>
          </div>
        </ModalHeader>
        <ModalBody>
          <Label className={"normal-font-bold"}>
            {t("cdt.exitWarning.text", { sec })}
          </Label>
        </ModalBody>
      </Modal>
    );
  }

  ////// PROPS ////////
  static propTypes = {
    /** Set the modal is open or not */
    isOpen: PropTypes.bool,
    /** Maximum value of counter */
    counter: PropTypes.number,
    /** Callback function counter is 0 */
    handleOnIdle: PropTypes.func
  };
}

export const LogOutModal = router(
  translate()(
    connect(
      null,
      null
    )(LogOutModalComponent)
  )
);
